import script from "./SafeguardingDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafeguardingDisclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./SafeguardingDisclaimer.vue?vue&type=style&index=0&id=48787556&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48787556"]])

export default __exports__